import type { ECouponDataSource } from '~/api/data-source/e-coupon';
import { eCouponDataSource } from '~/api/data-source/e-coupon';
import type { OAISchema } from '~/types/openapi';

// Response 타입
type ECouponDetail = OAISchema['ECouponDetailResponse'];

export interface ECouponRepository {
  getECouponDetail(eCouponId: string): Promise<ECouponDetail>;
}

export class ECouponRepositoryImpl implements ECouponRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: ECouponDataSource = eCouponDataSource,
  ) {}

  async getECouponDetail(eCouponId: string) {
    return this.dataSource.getECouponDetail(eCouponId);
  }
}

export const eCouponRepository = new ECouponRepositoryImpl();
